import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { CustomModalBasicProps } from '../../../../../components/CustomModal';
import { TaskWrapper, WrappedTask } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Task';
import TaskModal from 'src/careflow/care-coordination/task/patient/TasksGrid/TaskModal';

interface Props extends CustomModalBasicProps {
  patient: WrappedPatient | null;
  task?: WrappedTask | null;
  open: boolean;
  handleSave: (data: any) => void;
  onClose: () => void;
}

const EditTaskDialog = ({ patient, task, open, onClose, handleSave }: Props) => {
  const taskWrapped = task ? TaskWrapper(task) : undefined;
  return (
    <TaskModal
      taskToEdit={taskWrapped}
      onSuccessfulEdit={handleSave}
      onSuccessfulCreation={handleSave}
      patientExternal={patient}
      open={open}
      onClose={onClose}
    />
  );
};

export default EditTaskDialog;
